export default "__VITE_ASSET__e82d5fc9__"